import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import { toast, ToastContainer, Slide } from 'react-toastify';
import 'react-phone-number-input/style.css';
import theme from 'config/theme';

import Routes from './Routes';


const App = () => (
  <ThemeProvider theme={theme}>
    <ToastContainer
      autoClose={3000}
      draggable={false}
      position={toast.POSITION.BOTTOM_CENTER}
      hideProgressBar
      type={toast.TYPE.INFO}
      transition={Slide}
      className="toast-container"
      toastClassName="toast"
      bodyClassName="toast-body"
      progressClassName="toast-progress"
    />
    <BrowserRouter>
      <Routes />
    </BrowserRouter>
  </ThemeProvider>
);

export default App;
